/**
 * Name-keyed guards for the small duct meshes embedded in speaking GLBs.
 *
 * These are intentionally conservative: only the two exporter names below
 * are special. The broad head/teeth material managers must retain their
 * existing behavior for every real facial mesh.
 */

function normalizedName(value) {
    return typeof value === "string" ? value.trim().toLowerCase() : "";
}

function hasPrefix(value, prefix) {
    return normalizedName(value).startsWith(prefix);
}

export function materialsForMesh(mesh) {
    if (!mesh || !mesh.material) return [];
    return Array.isArray(mesh.material) ? mesh.material : [mesh.material];
}

export function isTeethDuctMaterial(material) {
    return hasPrefix(material && material.name, "teethducthead");
}

export function isEyeDuctMaterial(material) {
    return hasPrefix(material && material.name, "eyeductmaterial");
}

export function isTeethDuctMesh(mesh) {
    return (
        hasPrefix(mesh && mesh.name, "teethducthead") ||
        materialsForMesh(mesh).some(isTeethDuctMaterial)
    );
}

export function isEyeDuctMesh(mesh) {
    return (
        hasPrefix(mesh && mesh.name, "eyeducthead") ||
        materialsForMesh(mesh).some(isEyeDuctMaterial)
    );
}

export function isDuctMesh(mesh) {
    return isTeethDuctMesh(mesh) || isEyeDuctMesh(mesh);
}

/**
 * Preserve the authored black teeth duct base color without replacing or
 * otherwise restyling its native material. This is safe to run after any
 * broad material setup and supports Blender's ".001" material suffixes.
 */
export function enforceTeethDuctBlack(model) {
    if (!model || typeof model.traverse !== "function") return 0;

    let enforced = 0;
    model.traverse((child) => {
        if (!child || !child.isMesh) return;

        materialsForMesh(child).forEach((material) => {
            if (!isTeethDuctMaterial(material) || !material.color) return;

            material.color.setHex(0x000000);
            material.needsUpdate = true;
            enforced++;
        });
    });

    return enforced;
}